import React from 'react';
import styled, { css } from 'styled-components';

import {
  IconButton,
  ButtonType,
  ButtonTone,
} from '@prisjakt/ui/button/variants';
import Badge from '../badge';
import { useAppContext } from '@prisjakt/ui-app-context';
import { IconGiftBox } from '@prisjakt/ui/icon';

type Props = {
  onClickHandler: React.MouseEventHandler<
    HTMLAnchorElement | HTMLButtonElement
  >;
  alternatePosition?: boolean;
};

export const ChangelogToggle: React.FC<Props> = ({
  onClickHandler,
  alternatePosition,
}) => {
  const { t } = useAppContext();

  return (
    <Button
      onClick={onClickHandler}
      $alternateStyling={alternatePosition}
      type={alternatePosition ? ButtonType.TEXT : ButtonType.TONAL}
      tone={alternatePosition ? ButtonTone.LIGHT : ButtonTone.DARK}
      ariaLabel={t('changelog', 'changelog.title')}
    >
      <Inner $alternateStyling={alternatePosition}>
        <Badge noOutline={alternatePosition} />
        <IconGiftBox size={20} color="base0" />
      </Inner>
    </Button>
  );
};

type StyleProps = {
  $alternateStyling?: boolean;
};

const Button = styled(IconButton)<StyleProps>(
  p => css`
    && {
      ${p.$alternateStyling &&
        css`
          position: relative;
          color: ${p.theme.icons.secondary};
        `};
    }
  `
);

const Inner = styled.div<StyleProps>`
  position: ${p => (p.$alternateStyling ? 'relative' : 'unset')};
  display: flex;
`;
